import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { SuperAdminTopTextSearchIcon } from "../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { FormControl, Select, TextField } from "@material-ui/core";
import {
  userWalletTransactions
} from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Pending from "./Pending";
import isEmpty from "../../../../store/validation/is-Empty";
import { useDispatch } from "react-redux";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { MenuItem, Menu } from "@material-ui/core";
import { Row, Col } from "react-bootstrap";
import { InputLabel } from "@material-ui/core";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import moment from "moment";
import { userCloseWalletRequests } from "../../../../store/actions/SuperAdminActions/closeWalletAction";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { errorAlert, successAlert } from "../../../../function/alert";
import { amApi } from "../../../../api/apiHelper";
import Processed from "./Processed";

const CloseWalletRequests = (props) => {
  //state
  const dispatch = useDispatch();
  const token = props.auth.user.accessToken;
  const [dateQuery, setDateQuery] = useState({});
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [page, setPage] = useState(1);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    let calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
    //page = pageNo;
  };

  // const handleShowFilter = () => {
  //   setShowFilter({
  //     showFilter: false,
  //   });
  // };

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  const [transactionId, setTransactionId] = useState();
  const [statusType, setStatusType] = useState();
  const [showAccept, seShowAccept] = useState(false);
  const [showReject, seShowReject] = useState(false);
  const [showReason, seShowReason] = useState(false);
  const [reference, setReference] = useState('');
  const [stage, setStage] = useState(0);
  const handleCloseAccept = () => seShowAccept(false);
  const handleShowAccept = (id, status) => {
    setTransactionId(id);
    setStatusType(status);
    seShowAccept(true);
  };
  const handleCloseReject = () => seShowReject(false);
  const handleShowReject = (id, status) => {
    setTransactionId(id);
    setStatusType(status);
    seShowReject(true);
  };
  const handleCloseReason = () => seShowReason(false);
  const handleShowReason = () => {
    seShowReason(true);
    seShowReject(false);
  };

  const [state, setState] = useState({
    reason: "",
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
  });

  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const selecthandleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };

  const onSuccess = () => {
    const token = props.auth.user.accessToken;
    props.userWalletTransactions(token);
    handleCloseAccept();
    handleCloseReject();
  };

  const [selectedSort, setSelectedSort] = useState("namea-z");

  const sortByChangeCode = (id) => {
    setSelectedSort(id);
  };

  const changeStatus = async () => {
    if (!reference) {
      errorAlert('Please Enter Reference ID to Proceed')
    }
    const data = await amApi.patch(`/closeWallet/${transactionId}`, {
      status: 'PROCESSED',
      referenceId: reference
    });
    if (data.status === 200) {
      successAlert('Processed Succefully');
      setReference('');
      seShowAccept(false);
      filteredData = filteredData.filter(ele => ele._id !== transactionId);
    } else {
      errorAlert('Something Went wrong, try again later');
    }
  }

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        userCloseWalletRequests(
          {
            status: stage === 0 ? "PENDING" : 'PROCESSED', startDate: dateQuery?.startDate,
            endDate: dateQuery?.endDate
          }
        )
      );
    }
  }, [dateQuery, stage]);

  // useEffect(() => {
  //   if (!isEmpty(props.user_wallet_transactions)) {
  //     setWalletMoneyData(props.user_wallet_transactions);
  //   }
  // }, [props.user_wallet_transactions]);


  //serach bar//

  const [search, setSearch] = useState("");
  const onChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    status: "",
    transactionType: "",
    search: false
  });

  const userFilter = [
    { title: "User Name", disabled: true },
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
    { title: "Amount", disabled: true },
    { title: `Low to High 🠑`, disabled: false },
    { title: "High to Low 🠓", disabled: false },
  ];

  const walletFilter = {
    status: [{ value: false, name: "Pending" }, { value: true, name: "Processed" }],
  }

  let filteredData = props.closeWalletRequests || [];
  filteredData = filteredData.filter((item) => {
    return (
      item?.user_id?.first_name?.toLowerCase().includes(search.toLowerCase()) ||
      item?.user_id?.mobile_number?.toLowerCase().includes(search.toLowerCase())
    );
  });

  filteredData = filteredData
    .sort((a, b) =>
      selectedSort === "namea-z"
        ? a.user_id.first_name.toLowerCase() >
          b.user_id.first_name.toLowerCase()
          ? 1
          : -1
        : b.user_id.first_name.toLowerCase() >
          a.user_id.first_name.toLowerCase()
          ? 1
          : -1
    )
    .filter((offer) => offer);




  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState('')

  /*********************************
 * @DESC SORT FILTER ACTION
 *********************************/

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };


  if (sort === "A-Z") {
    filteredData = filteredData.sort((a, b) => {
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name <
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return -1;
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name >
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return 1;
      return 0;
    });
  } else if (sort === "Z-A") {
    filteredData = filteredData.sort((a, b) => {
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name <
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return 1;
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name >
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return -1;
      return 0;
    });
  } else if (sort === 'Low to High 🠑') {
    filteredData = filteredData.sort((a, b) => a.settleBalance - b.settleBalance)
  } else if (sort === 'High to Low 🠓') {
    filteredData = filteredData.sort((a, b) => b.settleBalance - a.settleBalance)
  }

  if (state.search) {
    let search = new RegExp(state.search, "i");
    filteredData = filteredData.filter((getall) => {
      if (
        search.test(
          getall?.user_id?.first_name + " " + getall?.user_id?.last_name
        )
      ) {
        return getall;
      } else {
        return false;
      }
    });
  }

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [search]);


  const downloadData = {
    headers: [
      { label: "ID", key: "id" },
      { label: "User Name", key: "name" },
      { label: "Mobile", key: "type" },
      { label: "Date & Time", key: "date" },
      { label: "Amount", key: "amount" },
      { label: "Status", key: "status" },
    ],
    data: filteredData ? filteredData?.map((ele) => {
      return {
        "id": ele?._id,
        "name": `${ele?.user_id?.first_name || ""} ${ele?.user_id?.last_name || ""}`,
        "type": `${ele.user_id?.mobile_number}`,
        "date": `${moment(ele?.createdAt).format("Do MMMM ,YYYY")} \n ${moment(ele?.createdAt).format("LT")}`,
        "amount": `₹ ${ele?.settleBalance}`,
        "status": `${ele.status}`,
      };
    }) : [],
  };
  
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Close Wallet Requests
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    name="search"
                    onChange={onSearchChange}
                    value={state.search}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center">
                    <div
                      className="f10-400"
                      align="center"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                      />
                      <br />
                      Sort
                    </div>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {userFilter.map((ele, index) => {
                        return (
                          <MenuItem
                            value={ele.title}
                            key={index}
                            onClick={() => setSort(ele.title)}
                            disabled={ele.disabled}
                          >
                            {ele.title}
                          </MenuItem>
                        );
                      })}
                    </Menu>
                    {/* <div className="f10-400" align="center">
                        <img
                          src={require("../../../../assets/images/iconButton/filtericon.png")}
                          width="35px"
                          alt="Filter Icon"
                          onClick={() => setShowFilter(!showFilter)} 
                        />
                        <br />
                        Filter
                      </div> */}
                    <CSVDownloader
                      filename={"Close_Wallet"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </div>
                {showFilter && (
                  <div
                    className="container-fluid p-4"
                    style={{
                      backgroundColor: "#ffffff",
                      transition: "height 2s",
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Status">
                              Status
                            </InputLabel>
                            <Select
                              value={filter.status}
                              onChange={(e) => setFilter({ ...filter, status: e.target.value })}
                              label="Status"
                              inputProps={{
                                name: "Status",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {walletFilter?.status.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="mt-5 d-flex">
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() => {
                          setFilter({
                            status: "",
                            transactionType: "",
                            search: false,
                          });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Confirm Button"
                        onClick={() => {
                          setFilter({ ...filter, search: true });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )}

              </div>
              <div className="d-flex  mt-3">
                <div
                  className={`mr-4 px-0 text-grayLink f12-500 btn btn-link  ${stage === 0 && "active"
                    }`}
                  onClick={() => {
                    setStage(0);
                  }}
                >
                  Pending
                </div>
                <div
                  className={`mr-4 px-0 text-grayLink f12-500 btn btn-link  ${stage === 1 && "active"
                    }`}
                  onClick={() => {
                    setStage(1);
                  }}
                >
                  Processed
                </div>
              </div>
              {stage === 0 && (
                <Pending
                  filteredData={filteredData}
                  handleShowAccept={(id, statusType) =>
                    handleShowAccept(id, statusType)
                  }
                  handleShowReject={(id, statusType) =>
                    handleShowReject(id, statusType)
                  }
                  start={start}
                  end={end}
                />
              )}

              {stage === 1 && (
                <Processed
                  filteredData={filteredData}
                  handleShowAccept={handleShowAccept}
                  handleShowReject={handleShowReject}
                  start={start}
                  end={end}
                />
              )}


              <Modal show={showAccept} onHide={handleCloseAccept} centered>
                <Modal.Header className="py-0 pt-2 border-0" closeButton>
                  <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="f16-500">
                  Are you sure you want to Process this request?

                  <div className="d-flex mt-4 align-items-center">
                    <NewInputText
                      extraClass="mb-0"
                      name="Reference ID"
                      inputType="string"
                      onChange={(e) => setReference(e.target.value)}
                      value={reference}
                      labelText="Reference ID"
                      controlClass={"outlined-helperText"}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-start border-0">
                  <Button
                    variant="outline-secondary"
                    className="btn mr-4 px-5"
                    onClick={handleCloseAccept}
                  >
                    No
                  </Button>
                  <Button
                    variant="danger"
                    className="btn px-5"
                    //onClick={handleCloseAccept}
                    onClick={() => changeStatus()}
                  >
                    Yes
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal show={showReject} onHide={handleCloseReject} centered>
                <Modal.Header className="py-0 pt-2 border-0" closeButton>
                  <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="f16-500">
                  Are you sure you want to reject this request?
                </Modal.Body>
                <Modal.Footer className="justify-content-start border-0">
                  <Button
                    variant="outline-secondary"
                    className="btn-lg mr-4 px-5"
                    onClick={handleCloseReject}
                  >
                    No
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-lg px-5"
                    //onClick={handleShowReason}
                    onClick={() => changeStatus()}
                  >
                    Yes
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal show={showReason} onHide={handleCloseReason} centered>
                <Modal.Header className="py-0 pt-2 border-0" closeButton>
                  <Modal.Title className="f24_700_HelveticaNeue">
                    Reason for Cancellation
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="f16-500">
                  <Form>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <Select
                          value={state.reason}
                          onChange={selecthandleChange}
                          inputProps={{
                            name: "reason",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <option value={"Other"}>Other</option>
                        </Select>
                      </FormControl>
                    </Form.Group>
                    <Form.Group>
                      <TextField
                        label="Enter Reason"
                        type="text"
                        variant="outlined"
                        multiline
                        rows="5"
                        className="w-100"
                      />
                    </Form.Group>
                    <div className="pt-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg btn150px mr-4 px-5"
                        onClick={handleCloseReason}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg btn150px px-5"
                        onClick={handleCloseReason}
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

CloseWalletRequests.propTypes = {
  auth: PropTypes.object.isRequired,
  userWalletTransactions: PropTypes.func.isRequired,
  userCloseWalletRequests: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  closeWalletRequests: state.userManagement.closeWalletRequests,
  user_wallet_transactions:
    state.superadminManageTransactions.user_wallet_transactions,
});

export default connect(mapStateToProps, {
  userWalletTransactions,
  userCloseWalletRequests,
})(CloseWalletRequests);
